module.exports = __webpack_public_path__ + "static/media/Barney Gumble.7f2351ec.png";